import NumberSystems from "./NumberSystems";

export default class ResultItem{
    /**
     *
     * @param value
     * @param numberSystem {Number}
     */
    constructor(value, numberSystem, 
        optionalPlus = false, optionalLeadingZeros = false, optionalTrailingZeros = false){
        if(!this.validateNumberSystem(numberSystem)){
            throw new Error("Invalid number system. Please use a constant from NumberSystems.js");
        }
        this.value = value;
        this.numberSystem = numberSystem;
        this.optionalPlus = optionalPlus;
        this.optionalLeadingZeros = optionalLeadingZeros;
        this.optionalTrailingZeros = optionalTrailingZeros;
    }

    getNumberSystem = () => {
        return this.numberSystem;
    };

    getValue = () => {
        return this.value;
    };

    plusCanBeRemoved = () => {
        return this.optionalPlus;
    };

    leadingZerosCanBeRemoved = () => {
        return this.optionalLeadingZeros;
    };

    trailingZerosCanBeRemoved = () => {
        return this.optionalTrailingZeros;
    };

    validateNumberSystem = (numberSystem) => {
        return(numberSystem === NumberSystems.DECIMAL ||
        numberSystem === NumberSystems.BINARY ||
        numberSystem === NumberSystems.HEXADECIMAL ||
        numberSystem === NumberSystems.OCTAL)
    }
}